export function stringToArray(input: string): Array<number> {
  return input.split(',').map((str) => parseInt(str))
}
